import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import "./solutions.scss";
import SwiperCore, { EffectFade, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Config from "../../../Config";

SwiperCore.use([Navigation, EffectFade]);

const MainSolutions = (props) => {
  const [title, setTitle] = useState(props?.iContent?.title?.value);
  const [tabs, setTabs] = useState(props?.iContent?.tabs?.expandedValue);
  const [tabIndex, setTabIndex] = useState(0);
  const [swiperInstence, setSwiperInstence] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [items, setItems] = useState(
    props?.iContent?.tabs?.expandedValue[tabIndex]?.items?.expandedValue,
  );
  const [itemInfo, setItemInfo] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const [textInfo, setTextInfo] = useState("");
  const [selectedRow, setSelectedRow] = useState(-1);
  const [index, setIndex] = useState(-1);
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    setItems(
      props?.iContent?.tabs?.expandedValue[tabIndex]?.items?.expandedValue,
    );
  }, [tabIndex]);

  const changeTab = (index) => {
    setTabIndex(index);
    setShowInfo(false);
    setItemInfo(null);
    setIndex(-1);
    setSelectedRow(-1);
  };

  const pickItem = (item) => {
    if (item != null && itemInfo == null) {
      setItemInfo(item);
      setShowInfo(true);
      let txt = item?.info?.value;
      setTextInfo(txt);
      setShowAnimation(true);
      if (txt.length - 7 > 120) {
        let end =
          txt.charAt(txt.length - 4) +
          txt.charAt(txt.length - 3) +
          txt.charAt(txt.length - 2) +
          txt.charAt(txt.length - 1);
        let partialStr = txt.slice(0, 119) + "...";
        if (isMobile) {
          partialStr = txt.slice(0, 59) + "...";
        }
        let newStr = partialStr + end;
        setTextInfo(newStr);
      }
    } else if (item == null) {
      setItemInfo(null);
      setShowInfo(false);
      setIndex(-1);
      setSelectedRow(-1);
      setShowAnimation(false);
    }
  };

  const len = items.length > 5 ? parseInt(items.length / 2) : items.length;
  const size = items.length;
  let startRow1 = 0;
  let endRow1 = size > 10 ? parseInt(size - size / 2) : 4;
  let startRow2 = endRow1 + 1;
  let endRow2 = size - 1;

  const infoBubbleDirection = (j) => {
    if (size < 5) {
      return j % 6 < 2;
    } else if (size < 10 && j >= startRow2) {
      return (j - startRow2) % 6 <= 2;
    }
    return j % 6 <= 2;
  };
  return (
    <div className="main-solutions-block">
      <div className="main-title">{title}</div>
      <div className="tabs">
        <div className="tabs-titles">
          {tabs != null &&
            tabs.map((item, i) => (
              <>
                <div
                  onClick={() => changeTab(i)}
                  className={`${tabIndex == i ? "isSelected" : ""} tab-title`}
                  key={i}
                >
                  {item?.tabTitle?.value}
                </div>
              </>
            ))}
        </div>
      </div>
      <div className={`${showInfo == true && !isMobile ? "" : ""} swiper-area`}>
        <div>
          <Swiper
            navigation={items?.length > 10 && !isMobile ? true : false}
            slidesPerView={isMobile ? 3.5 : 5}
            slidesPerColumn={2}
            centerInsufficientSlides={true}
            slidesPerColumnFill="row"
            onSwiper={(swiper) => {
              setSwiperInstence(swiper);
            }}
            effect="slide"
            onSlideChange={(swiper) => {
              setActiveIndex(swiper?.activeIndex);
            }}
          >
            {!isMobile &&
              items != null &&
              items?.map((val, j) => (
                <>
                  <SwiperSlide
                    key={j}
                    className={`slides-box ${
                      (selectedRow == 1 && j < len) ||
                      (j >= len && selectedRow == 2)
                        ? `decrease`
                        : `increase`
                    } `}
                  >
                    <div
                      className="item-style"
                      onClick={() => {
                        pickItem(val),
                          setIndex(j),
                          setSelectedRow(j >= 0 && j <= len ? 1 : 2);
                      }}
                      onMouseEnter={() => {
                        pickItem(val),
                          setIndex(j),
                          setSelectedRow(j >= 0 && j <= len ? 1 : 2);
                      }}
                      onMouseLeave={() => {
                        pickItem(null);
                      }}
                    >
                      <div className="img-location">
                        <Image src={
                            Config.epiBaseUrl +
                            val?.imageDesktop?.expandedValue?.url
                          } />
                      </div>
                      <div className="img-location-text">
                        {val?.text?.value}
                      </div>

                      {!isMobile &&
                        showInfo == true &&
                        val != null &&
                        index == j && (
                          <div
                            className={
                              infoBubbleDirection(j)
                                ? `${
                                    showAnimation ? "animate-in" : ""
                                  } info-box-desktop`
                                : "info-box-desktop-last"
                            }
                            onMouseLeave={() => {
                              pickItem(null);
                            }}
                            onMouseEnter={() => {
                              pickItem(val),
                                setIndex(j),
                                setSelectedRow(j >= 0 && j <= len ? 1 : 2);
                            }}
                            onClick={() => {
                              pickItem(val),
                                setIndex(j),
                                setSelectedRow(j >= 0 && j <= len ? 1 : 2);
                            }}
                          >
                            <div className="info-first-line">
                              <div className="img-info-box">
                                <Image src={
                                    Config.epiBaseUrl +
                                    itemInfo?.infoImage?.expandedValue?.url
                                  } />
                              </div>
                              <div className="info-title">
                                {itemInfo?.infoTitle?.value}
                              </div>
                            </div>
                            <div
                              className="info-summary"
                              dangerouslySetInnerHTML={{ __html: textInfo }}
                              onClick={() =>
                                props.context.navigateTo(itemInfo?.link?.value)
                              }
                            ></div>
                            <div
                              className="info-link"
                              onClick={() =>
                                props.context.navigateTo(itemInfo?.link?.value)
                              }
                            >
                              {itemInfo?.linkText?.value}
                            </div>
                          </div>
                        )}
                    </div>
                  </SwiperSlide>
                </>
              ))}

            {isMobile &&
              items != null &&
              items?.map((val, j) => (
                <>
                  <SwiperSlide key={j} className="slides-box">
                    <div
                      className="item-style"
                      onClick={() => pickItem(val)}
                      onMouseEnter={() => pickItem(val)}
                    >
                      <div className="img-location">
                        <Image src={
                            !isMobile
                              ? Config.epiBaseUrl +
                                val?.imageDesktop?.expandedValue?.url
                              : Config.epiBaseUrl +
                                val?.imageMobile?.expandedValue?.url
                          } />
                      </div>
                      <div className="img-location-text-mobile">
                        {val?.text?.value}
                      </div>
                    </div>
                  </SwiperSlide>
                </>
              ))}
          </Swiper>
        </div>
      </div>
      {isMobile && showInfo == true && (
        <div
          className={`${
            !isMobile && showInfo == true ? "animate-in" : ""
          } info-box`}
        >
          <div className="info-first-line">
            <div className="img-info-box">
              <Image src={
                  Config.epiBaseUrl + itemInfo?.infoImage?.expandedValue?.url
                } />
            </div>
            <div className="info-title">{itemInfo?.infoTitle?.value}</div>
            <div className="img-close" onClick={() => pickItem(null)}>
              {isMobile && (
                <div className="img-close-style">
                  <Image src={require("./images/close.svg")} />
                </div>
              )}
            </div>
          </div>
          <div
            className="info-summary"
            dangerouslySetInnerHTML={{ __html: textInfo }}
            onClick={() => props.context.navigateTo(itemInfo?.link?.value)}
          ></div>
          <div
            className="info-link"
            onClick={() => props.context.navigateTo(itemInfo?.link?.value)}
          >
            {itemInfo?.linkText?.value}
          </div>
        </div>
      )}
    </div>
  );
};

export default MainSolutions;
